import React from 'react';
import {ThemedView, ThemedText} from '@app/theme';
import Button from '@sharedComponents/Button/Button';

interface KYCUpdateViewProps {
  checkBox1Checked: boolean;
  checkBox2Checked: boolean;
  handleSuccess: () => void;
  setShowKYCUpdateConfirmationModal: (val: boolean) => void;
  colors: any;
}

const KYCUpdateView: React.FC<KYCUpdateViewProps> = ({
  checkBox1Checked,
  checkBox2Checked,
  handleSuccess,
  setShowKYCUpdateConfirmationModal,
  colors,
}) => {
  return (
    <ThemedView justifyContent={'flex-end'} bottom={0} mt={"sm"}>
      <ThemedView justifyContent={"flex-end"} borderTopWidth={1} borderColor={"border-primary"}/>
      <ThemedText variant={"b4r"} color={"text-primary"} ml={"sm"} textAlign={"center"} mt={"lg"}>
        Are the above KYC details correct?
      </ThemedText>
      <ThemedView paddingHorizontal={"lg"} paddingTop={"sm"} paddingBottom={"lg"}>
        <Button
          label="Yes, it's correct"
          type="SOLID"
          size='MD'
          disabled={!checkBox1Checked || !checkBox2Checked}
          handlePress={handleSuccess}
          bg={colors['bg-action-primary']}
          textColor={colors['text-primary']}
        />
        <ThemedView mt={"sm"} alignItems={"center"}>
          <Button
            label="I need to update my KYC details here"
            type="TEXT"
            size='MD'
            disabled={!checkBox1Checked || !checkBox2Checked}
            handlePress={() => setShowKYCUpdateConfirmationModal(true)}
            textColor={colors['text-primary']}
          />
        </ThemedView>
      </ThemedView>
    </ThemedView>
  );
};

export default KYCUpdateView; 